// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"62d8d14f","132":"10f8c429","190":"2b9baf9e","212":"ed95b85d","311":"cae129d5","453":"b72b36d6","506":"5ea0e943","751":"f68d9215","936":"42b6f73c"}[chunkId] + ".chunk.js";
};